<template>
  <v-dialog v-model="showDialog" max-width="600">
    <template v-slot:activator="{ props }">
      <kicklet-text-field
          class="img-picker-input"
          :model-value="itemValue ? (modelValue && modelValue[itemValue]) : modelValue"
          :label="label"
          :placeholder="placeHolder"
          v-bind="props"
          :readonly="true"
      >
        <template v-slot:append-inner>
          <v-icon icon="mdi-menu-down" @click="showDialog = !showDialog"></v-icon>
        </template>
        <template v-slot:append>
          <slot name="append"></slot>
        </template>
      </kicklet-text-field>
    </template>

    <v-card width="100%" min-height="500" class="ma-auto pa-5">
      <v-card-title class="text-center mb-1">
        {{ title }}
      </v-card-title>
      <v-sheet>
        <v-row>
          <v-col
              v-if="allowEmpty"
              cols="12"
              :sm="sm"
          >
            <v-list-item
                @click="select(undefined)"
                class="none-select mr-2 mb-2 d-flex flex-column align-center justify-center fill-height"
                :active="!modelValue || modelValue === ''"
            >
              None
            </v-list-item>
          </v-col>
          <v-col
              cols="12"
              :sm="sm"
              v-for="(item, i) in options"
              :key="i"
          >
            <v-list-item
                @click="select(item)"
                class="pa-2 d-flex flex-column align-center"
                :active="modelValue === item.value"
            >
              <v-img
                  :src="item.image"
                  width="100%"
                  height="100%"
              />
            </v-list-item>
          </v-col>
        </v-row>
      </v-sheet>
    </v-card>
  </v-dialog>
</template>

<script setup>
import { ref } from 'vue';
import KickletTextField from '@/components/custom/kicklet/KickletTextField.vue';

const props = defineProps({
  modelValue: {
    required: false,
  },
  itemValue: String,
  label: String,
  placeHolder: String,
  allowEmpty: {
    type: Boolean,
    default: false,
  },
  title: {
    type: String,
    default: 'Select an Image',
  },
  sm: {
    type: Number,
    default: 6,
  },
  options: {
    type: Array,
    default: () => [],
  },
});

const emit = defineEmits(['update:modelValue']);

const showDialog = ref(false);

function select (item) {
  if (item) {
    let value = item.value;
    if (props.itemValue) {
      value = item;
    }
    emit('update:modelValue', value);
  } else {
    emit('update:modelValue', undefined);
  }
  showDialog.value = false;
}

</script>

<style>
.img-picker-input input {
  cursor: pointer;
}

.none-select {
  font-size: 15px;
  width: 100%;
}
</style>
